import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-client-archived-badge',
  standalone: true,
  imports: [NgIf],
  template: `
    <span
      *ngIf="visible"
      class="text-[10px] font-semibold text-[#92400e] bg-[#fde68a] inline-flex items-center px-2 py-0.5 rounded-full ml-1.5 align-middle whitespace-nowrap"
      title="This client record is currently archived"
    >
      Archived
    </span>
  `,
})
export class ClientArchivedBadgeComponent {
  @Input() visible = false;
}
